/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TrustedForwarder,
  TrustedForwarderInterface,
} from "../TrustedForwarder";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "from",
            type: "address",
          },
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct TrustedForwarder.ForwardRequest",
        name: "req",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "execute",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
    ],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "from",
            type: "address",
          },
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct TrustedForwarder.ForwardRequest",
        name: "req",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "verify",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type TrustedForwarderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TrustedForwarderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TrustedForwarder__factory extends ContractFactory {
  constructor(...args: TrustedForwarderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TrustedForwarder";
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TrustedForwarder> {
    return super.deploy(overrides || {}) as Promise<TrustedForwarder>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TrustedForwarder {
    return super.attach(address) as TrustedForwarder;
  }
  override connect(signer: Signer): TrustedForwarder__factory {
    return super.connect(signer) as TrustedForwarder__factory;
  }
  static readonly contractName: "TrustedForwarder";

  public readonly contractName: "TrustedForwarder";

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TrustedForwarderInterface {
    return new utils.Interface(_abi) as TrustedForwarderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TrustedForwarder {
    return new Contract(address, _abi, signerOrProvider) as TrustedForwarder;
  }
}
